import { render, staticRenderFns } from "./SetPin.vue?vue&type=template&id=48a1a669&scoped=true&"
import script from "./SetPin.vue?vue&type=script&lang=js&"
export * from "./SetPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a1a669",
  null
  
)

export default component.exports